import React from 'react';
import Corousel from './corousel';
import AboutUs from './aboutus';
import Reasons from './reasons';
import Causes from './causes';
import Sponsors from './sponsors';
import Footer from './footer';

const Home = () => (
    
    <div>
        <Corousel></Corousel>
        <AboutUs></AboutUs>
        <Reasons></Reasons>
        <Causes></Causes>
        <Sponsors></Sponsors>
        <Footer></Footer>
    </div>
);

export default Home; 